import { render } from "./LinkChain.vue?vue&type=template&id=76584f67&scoped=true"
import script from "./LinkChain.vue?vue&type=script&lang=js"
export * from "./LinkChain.vue?vue&type=script&lang=js"

import "./LinkChain.vue?vue&type=style&index=0&id=76584f67&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76584f67"],['__file',"src/components/LinkChain.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "76584f67"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('76584f67', __exports__)) {
    api.reload('76584f67', __exports__)
  }
  
  module.hot.accept("./LinkChain.vue?vue&type=template&id=76584f67&scoped=true", () => {
    api.rerender('76584f67', render)
  })

}


export default __exports__